<template>

    <data-variable-base :value="value" :variable="variable" @delete="emitDelete(variable)">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                mode="lazy"
                :name="variable.name"
                :vid="variable.name"
                rules="required|phone|max:30"
                v-slot="{ errors }">

                <!--    <v-text-field
                        v-show="!isMasked"
                        v-model="model"
                        :label="variable.name.replace('_',' ')"
                        :disabled="isDisabled"
                        :persistent-hint="!!hint"
                        :hint="hint"
                        placeholder="NO RECORDED VALUE"
                        :counter="100"
                        :hide-details="!hint && errors.length === 0 && !errorMessages[variable.name]"
                        :error-messages="errors.length > 0 ? errors : errorMessages[variable.name]"
                    ></v-text-field>-->

                <div v-if="errorMessages.length > 0 || errors.length > 0" class="red--text caption">
                    {{variable.name}}
                </div>

                <div v-else class="grey--text text--lighten-2 caption">
                    {{ variable.name }}
                </div>

                <vue-tel-input v-model="model"
                               v-show="!isMasked"
                               placeholder="NO RECORDED VALUE"
                               :disabled="isDisabled"
                               :wrapperClasses="wrapperClasses"
                               :inputClasses="inputClasses"
                               @validate="validatePhone"
                               @focus="emitAllowed=true"
                               @open="emitAllowed=true"
                ></vue-tel-input>

                <div v-show="errorMessages.length > 0" class="red--text">
                    {{ errorMessages[0] }}
                </div>

                <div v-show="errors.length > 0" class="red--text">
                    {{ errors[0] }}
                </div>

            </validation-provider>

        </validation-observer>

    </data-variable-base>
</template>

<script>

import {dataVariableInputMixin} from './dataVariableInputMixin';
import MaskedField from './MaskedField';
import DataVariableBase from "./DataVariableBase";

import {VueTelInput} from 'vue-tel-input'
import {extend} from "vee-validate/dist/vee-validate.full";

export default {

    mixins: [dataVariableInputMixin],

    components: {
        DataVariableBase,
        MaskedField,
        VueTelInput
    },

    props: {
        value: {
            type: String | null,
            required: true
        },
    },

    data() {
        return {
            emitModel: null,
            emitAllowed: false,
        }
    },

    watch: {
        value(value) {
            this.model = value;
        },
    },

    computed: {

        wrapperClasses() {
            return ['wrapper-dark'];
        },

        inputClasses() {
            return ['input-dark', 'body-1', 'grey--text', 'text--lighten-2'];
        }
    },

    methods: {

        validatePhone({number, isValid, country}) {

            // Hack, vue-tel-input emit @validate event when it is first rendered
            if (!this.emitAllowed) return;

            if (isValid) {
                this.valid = true;

                this.emitModel = number.e164;
                this.$refs.validationObserver.reset();

            } else {
                this.valid = false;
                this.emitModel = number.e164;

                let errors = {};
                errors[this.variable.name] = ['Invalid phone number format for the selected country'];

                this.$refs.validationObserver.reset();
                this.$refs.validationObserver.setErrors(errors);
            }
            this.emit(this.emitModel);

        },
    },

    created() {
        extend('phone', (value) => {

            if (value[0] !== '+') {
                return 'Phone number must begin with +';
            }

            let plainValue = value.replaceAll('-', '');
            plainValue = plainValue.replaceAll('(', '');
            plainValue = plainValue.replaceAll(')', '');
            plainValue = plainValue.replaceAll(' ', '');
            plainValue = plainValue.replaceAll('+', '');

            const result = /\D/.test(plainValue);

            if (result) {
                return "Invalid phone number";
            }

            return true;
        });
    }
}
</script>

<style>

.vti__dropdown-list {
    padding: 0px !important;
    margin: 0px !important;
    background-color: #424242 !important;
    color: white;
    border: 0px;
}

.vti__dropdown-arrow {
    color: white;
}

.highlighted {
    background-color: #525252 !important;
}

.wrapper-dark {
    background-color: transparent !important;
    padding-top: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid lightgrey !important;
}

.wrapper-dark div {
    padding: 3px !important;
    margin: 0px !important;
    background-color: transparent !important;
}

</style>
